<template>
    <div>
         <div class="divbutton">
            <a class="btn btn-info read-more btn-sm" v-if="!showMoreActivated" @click="activateReadMore">
            <i class="mdi mdi-arrow-down"></i>
            </a>
        </div>
        <div>
            <b-card v-if="showMoreActivated">
                <v-zoomer><img :src="'data:image/jpeg;base64,'+ image" class="w-100 h-100"/></v-zoomer>
            </b-card>
        </div>        
        <br />
        <div class="divbutton">
            <a class="btn btn-info read-more btn-sm" v-if="showMoreActivated" @click="deactivateReadMore">
            <i class="mdi mdi-arrow-up"></i>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: "ImageCollapserExpander",
    props: [ 'image' ],
    data() {
        return {
            showMoreActivated: false
        }
    },
    methods: {
        activateReadMore(){
            this.showMoreActivated = true;
        },
        deactivateReadMore(){
            this.showMoreActivated = false;
        },
    }
}
</script>
<style>
    .read-more{
        color: white !important;
    }
    .divbutton{
        text-align: center;
        margin-top: 10px;
    }
</style>